import styled from '@emotion/styled'

import { useTheme } from '@emotion/react'

import Image from '@segment/matcha/components/Image'

import unifyCustomerProfilePng from './assets/UnifyCustomerProfile.png'
import unifyCustomerProfilePng2x from './assets/UnifyCustomerProfile@2x.png'
import unifyCustomerProfileWebp from './assets/UnifyCustomerProfile.webp'
import unifyCustomerProfileWebp2x from './assets/UnifyCustomerProfile@2x.webp'

import unifyCustomerProfileMobilePng2x from './assets/UnifyCustomerProfileMobile@2x.png'
import unifyCustomerProfileMobileWebp from './assets/UnifyCustomerProfileMobile.webp'
import unifyCustomerProfileMobileWebp2x from './assets/UnifyCustomerProfileMobile@2x.webp'

const UnifyCustomerProfileImage = () => {
  const theme = useTheme()
  return (
    <Picture>
      <source
        type="image/webp"
        media={theme.breakpoints.up(`lg`, false)}
        srcSet={`${unifyCustomerProfileWebp}, ${unifyCustomerProfileWebp2x} 2x`}
        width="624"
        height="404"
      />
      <source
        media={theme.breakpoints.up(`lg`, false)}
        srcSet={`${unifyCustomerProfilePng}, ${unifyCustomerProfilePng2x} 2x`}
        width="624"
        height="404"
      />
      <source
        type="image/webp"
        srcSet={`${unifyCustomerProfileMobileWebp}, ${unifyCustomerProfileMobileWebp2x} 2x`}
        width="315"
        height="556"
      />
      <Image
        src={unifyCustomerProfileMobilePng2x}
        alt="Illustration: Unify customer profile"
        width="315"
        height="556"
        loading="lazy"
      />
    </Picture>
  )
}

const Picture = styled.picture`
  filter: drop-shadow(${({ theme }) => theme.shadows[2]});
`

export default UnifyCustomerProfileImage
